
import Vue from 'vue'
import { mains, subs } from '@/assets/menu'
import { IMenuProps } from '@/entities/Menu'

const component = Vue.extend({
  data() {
    return {
      menus: mains,
      subs
    }
  },
  computed: {
    __current(): string | null {
      return this.$route.name?.split('-')[0] || null
    }
  },
  methods: {
    authority(menu: IMenuProps): boolean {
      // ユーザーロールによって見れないページのときはfalse
      return !(menu.policy && !menu.policy.includes(this.App.user.entity.role))
    }
  }
})

Vue.component('MNavigationDrawer', component)
export default component
